import * as React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'

const FormSection = ({ section, className = '' }) => {
  return <section className={className}>
    This is a form section with ${section.form} fields and aside ${section.aside ? 'On' : 'Off'} / ${section.asideWidth}
  </section>
}

FormSection.propTypes = {
  section: PropTypes.shape({
    form: PropTypes.string,
    aside: PropTypes.bool,
    asideWidth: PropTypes.string,
  }),
  className: PropTypes.string
}

FormSection.defaultProps = {
  section: {
    form: '',
    aside: false,
    asideWidth: '',
  },
  className: ''
}


export const query = graphql`
    fragment FormSection on STRAPI__COMPONENT_SECTION_FORM {
        id
        form
        strapi_component
    }
`

export default FormSection